"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const theme_1 = __importDefault(require("@streem/ui-react/src/styles/theme"));
function MutedOnCallMessage() {
    return ((0, jsx_runtime_1.jsxs)(MuteModalOnCall, { children: [(0, jsx_runtime_1.jsx)(MutedIcon, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "MutedIcon", style: { width: '100%', height: '100%', margin: 'auto 0' } }) }), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "white", style: { margin: 'auto 0px auto 16px' } }, { children: "You are muted, please unmute by clicking the mic icon" }))] }));
}
exports.default = MutedOnCallMessage;
const MuteModalOnCall = ui_react_1.styled.div `
    position: fixed;
    top: 62vh;
    width: 90%;
    z-index: 40;
    display: flex;
    padding: 8px 16px;
    border-radius: 11px;
    background-color: rgba(61, 61, 61, 0.3);
    box-shadow: ${props => props.theme.shadow.small};
    color: ${props => props.theme.text.color.white};
    font-size: ${props => props.theme.text.size.medium};
`;
const MutedIcon = ui_react_1.styled.span `
    background-color: ${theme_1.default.colors.grey05};
    border-radius: 25px;
    padding: 5px;
    width: 40px;
    height: 40px;
    margin: auto 0px;
`;
//# sourceMappingURL=muted_on_call_message.js.map